import { abTestVariantTypes } from '/src/features/ab-testing/constants';

export const AB_TEST_RESULT_COLOR_MATRIX = [
  { tw: 'bg-dodger-blue-300', hex: '#99cff5' },
  { tw: 'bg-lima-500', hex: '#8abc00' },
  { tw: 'bg-pink-salmon-500', hex: '#ff8fa7' },
  { tw: 'bg-dandelion-500', hex: '#ffd155' },
  { tw: 'bg-dodger-blue-500', hex: '#0086e6' },
  { tw: 'bg-wisteria-500', hex: '#8f6bba' },
  { tw: 'bg-[#8EDEC5]', hex: '#8EDEC5' },
  { tw: 'bg-[#FFAF8F]', hex: '#FFAF8F' },
  { tw: 'bg-[#FF7679]', hex: '#FF7679' },
];

export const CONTROL_VARIANT_COLOR = { tw: 'bg-lavender-500', hex: '#ba89f5' };
export const DEFAULT_VARIANT_COLOR = { tw: 'bg-[#A5ACBC]', hex: '#A5ACBC' };

export function getAbTestVariantColor(variant) {
  if (variant?.type === abTestVariantTypes.CONTROL) {
    return CONTROL_VARIANT_COLOR;
  }

  return AB_TEST_RESULT_COLOR_MATRIX[variant?.position] ?? DEFAULT_VARIANT_COLOR;
}
